// extracted by mini-css-extract-plugin
export default {"ctn":"Banner_ctn__PDe78","main":"Banner_main__wEu9H","title":"Banner_title__CPCp2"};